import { render, staticRenderFns } from "./TempCreate3.vue?vue&type=template&id=3b27c419&scoped=true"
import script from "./TempCreate3.vue?vue&type=script&lang=js"
export * from "./TempCreate3.vue?vue&type=script&lang=js"
import style0 from "./TempCreate3.vue?vue&type=style&index=0&id=3b27c419&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27c419",
  null
  
)

export default component.exports